import { Component } from 'react';
import { RouteComponentProps, StaticContext, withRouter } from 'react-router';
import { defaultPagination } from 'src/constants/main';
import { localeStore } from 'src/mobx/localesStore';
import client from 'src/services/client';
import { IPagination } from 'src/types/main';
import { TransactionStatus } from '~/view/components/Transaction/TransactionStatus';
import { TOrderTransactionLog } from 'src/types/orders';
import { formatPrice } from 'src/utils/formatter';
import { formatDate } from 'src/utils/helpers';
import Pagination from 'src/view/components/Controls/PaginationOld/PaginationOld';
import logger from '~/services/logger';
import './style.scss';

type TProps = RouteComponentProps<{ id: string }, StaticContext, undefined>;

interface State {
  pagination: IPagination<TOrderTransactionLog | undefined>;
}

const RenderHeaderItem = (item: { text: string; className?: string }) => {
  return (
    <p className={`family-medium color-gray2 text-size-12 text-uppercase letter-spacing-12 ${item.className || ''}`}>{localeStore.t(item.text)}</p>
  );
};

const RenderItem = (item: { text: string | number | React.ReactNode; className?: string }) => {
  return <p className={`family-medium color-dark text-size-16 ${item.className || ''}`}>{item.text}</p>;
};

class OrderTransactionLogsList extends Component<TProps, State> {
  state = {
    pagination: defaultPagination,
  };

  componentDidMount = () => {
    this.fetchList();
  };

  fetchList = async (page: number = this.state.pagination.current_page + 1) => {
    try {
      if (typeof page !== 'number') page = this.state.pagination.current_page + 1;

      this.setState((state) => ({ pagination: { ...state.pagination, loading: true, refreshing: true } }));
      const pagination: IPagination<TOrderTransactionLog> = await client.get(`v3/orders/${this.props.match.params.id}/transactions`, {
        params: { page, details: 1 },
      });
      this.setState({ pagination: { ...pagination, loading: false, refreshing: false, data: pagination.data } });
    } catch (error: any) {
      this.setState((state) => ({ pagination: { ...state.pagination, loading: false, refreshing: false } }));
      logger.error({ error, place: 'OrderTransactionLogsList fetchList' });
    }
  };

  renderLog = (log: TOrderTransactionLog) => {
    return (
      <div className="order-transaction-log-list__table-string d-flex flex-row gap-15 py-3">
        <RenderItem text={log.transaction_id || '—'} className="order-transaction-log-list_large" />
        <RenderItem text={log.username || '—'} />
        <RenderItem text={log.action_name} />
        <RenderItem text={<TransactionStatus status={log.status} />} className="inline" />
        <RenderItem text={formatDate(log.created_at, {})} />
        <RenderItem text={localeStore.t(`${log.payment_type}_payment_type`)} />
        <RenderItem text={formatPrice(log.amount, log.currency_code)} />
        <RenderItem text={log.reason || '—'} />
        <RenderItem text={log.arn || '—'} className="order-transaction-log-list_medium" />
      </div>
    );
  };

  render() {
    return (
      <div className="order-transaction-log-list d-flex flex-column full-height">
        <div className="order-transaction-log-list__table full-height">
          <div className="d-flex flex-row gap-15 mb-4">
            <RenderHeaderItem text="checkout_id" className="order-transaction-log-list_large" />
            <RenderHeaderItem text="author" />
            <RenderHeaderItem text="Action" />
            <RenderHeaderItem text="Status" />
            <RenderHeaderItem text="Time" />
            <RenderHeaderItem text="payment_type" />
            <RenderHeaderItem text="Value" />
            <RenderHeaderItem text="refund_reason" />
            <RenderHeaderItem text="transaction_arn_code" className="order-transaction-log-list_medium" />
          </div>
          {this.state.pagination.data.map(this.renderLog)}
        </div>

        <Pagination pagination={this.state.pagination} onChange={this.fetchList} />
      </div>
    );
  }
}

export default withRouter(OrderTransactionLogsList);
